<template>
 <div
    v-if="schoolSelected && isOpen == true"
        id="schoolPopup"
        class="school-info-container flex h-auto w-full rounded-3xl mb-3 lg:absolute"
        :class="{ 'bg-beige': onPromo, 'bg-black text-white': darkTheme, 'bg-white': !darkTheme }"
        >
        <div
            class="school-info-container__content flex justify-between w-full lg:mt-0 mt-4"
        >
            <div class="flex flex-col sm:ml-2 w-full">
                <span class="font-bold bgc-dark mb-2 text-xl">
                    {{ schoolSelected.title }}
                </span>
                <p class="bgc-dark mb-2 text-base">{{ schoolSelected.address }}</p>

                <div class="flex flex-start mb-1 mt-2">
                    <div class="flex items-center w-4 mr-3">
                        <!-- phone -->
                        <svg width="6" height="13" viewBox="0 0 6 13" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.872 9.622v1.763c.003.322-.102.597-.3.795-.197.197-.472.305-.796.311-.14.003-.28.001-.415-.002-.198-.004-.386-.01-.57.008-.005.002-.01 0-.015.002-.507.02-.952-.16-1.323-.53a3.116 3.116 0 0 1-.098-.105c-.515-.586-.802-1.285-.997-1.829a10.68 10.68 0 0 1-.555-4.478c.114-1.273.373-2.31.812-3.268.178-.39.475-.963.98-1.392A1.651 1.651 0 0 1 3.687.502L4.782.5h.006c.314.007.585.115.78.311.197.196.302.464.304.773.008.2.007.404.004.6-.003.099-.002.201-.002.3l.002.875c.001.673-.433 1.108-1.106 1.107h-.271c-.239.002-.486.004-.737-.008a4.578 4.578 0 0 0-.248 1.115c-.092.921-.052 1.745.123 2.52.018.076.045.158.074.244l.06.188 1.01.004c.324 0 .599.105.796.303.2.199.3.473.295.79z" :fill="darkTheme ? '#fff' : '#2B2034'" fill-rule="nonzero"/>
                        </svg>
                    </div>
                    <p class="text-xs underline w-full bgc-dark">
                        {{ schoolSelected.phone }}
                    </p>
                </div>
                <div class="flex flex-start mb-1">
                    <div class="flex items-center w-4 mr-3">
                        <!-- whatsapp -->
                        <svg width="14" height="13" viewBox="0 0 14 13" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.577.46h-.003a6.005 6.005 0 0 0-5.998 6c0 1.313.423 2.53 1.142 3.517l-.748 2.23 2.306-.738c.949.629 2.08.992 3.301.992a6.006 6.006 0 0 0 5.999-6c0-3.309-2.69-6-5.999-6zm3.491 8.473c-.144.41-.719.748-1.177.847-.314.067-.723.12-2.102-.451-1.763-.73-2.898-2.523-2.987-2.639-.085-.116-.712-.949-.712-1.81 0-.86.437-1.28.613-1.46.145-.148.384-.215.614-.215.074 0 .14.004.2.007.177.007.265.018.382.296.144.349.497 1.21.539 1.298.043.089.085.209.025.325-.056.12-.105.173-.194.275-.088.102-.172.18-.261.29-.081.095-.172.197-.07.373.102.173.454.748.973 1.21.67.596 1.213.787 1.407.868.145.06.317.045.423-.067.134-.145.3-.385.469-.621.12-.17.271-.19.43-.13.162.056 1.02.48 1.196.567.176.089.292.13.335.205.042.074.042.423-.103.832z" :fill="darkTheme ? '#fff' : '#2B2034'" fill-rule="nonzero"/>
                        </svg>

                    </div>
                    <p class="text-xs underline w-full bgc-dark">
                        {{ schoolSelected.phone }}
                    </p>
                </div>
                <div v-if="schoolSelected.timetable" class="flex flex-col timetable mt-2 text-xs" v-html="schoolSelected.timetable[lang]"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        schoolSelected:{
            type: Object,
            required: true
        },
        isOpen: {
            type: Boolean,
            required: true
        },
        onPromo: {
            type: Boolean,
            default: false
        },
        darkTheme: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            lang: window.appLocale
        }
    }
}
</script>

<style lang="scss">
.school-container {
    border-radius:26px !important;
    .school-info-container {
        max-width: 320px;
        bottom: -26px;
        right: 13px;
        margin: 3rem;
        box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.15);
        .img-x  {
            position: absolute;
            top: 10px;
            right: 15px;
            @media (max-width: 400px) {
                right: 12px;
            }
        }
        @media (max-width: 640px) {
            max-width: 300px;
        }
        @media (max-width: 400px) {
            max-width: 275px;
        }
        @media (max-width: 375px) {
            max-width: 265px;
        }
    }
}
.timetable {
        p {
            font-size: 12px !important;
            margin-bottom: .2rem;
        }
}
</style>
